export default {
  header: 'Browser not supported',
  mainText: 'This browser is not supported',
  link: 'Open in app',
  imgAlt: 'logo',
};
